import { render, staticRenderFns } from "./work-record.vue?vue&type=template&id=2e9ad2e0&scoped=true"
import script from "./work-record.vue?vue&type=script&lang=js"
export * from "./work-record.vue?vue&type=script&lang=js"
import style0 from "./work-record.vue?vue&type=style&index=0&id=2e9ad2e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9ad2e0",
  null
  
)

export default component.exports